import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { FAQS } from '@/lib/site';
import { motion } from 'framer-motion';

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <p className="eyebrow">Honest answers</p>
            <h2 className="h-display mt-4 text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.05] text-maroon-700 dark:text-foreground">
              Questions you
              <br />
              <span className="italic font-serif saffron-text">should ask.</span>
            </h2>
            <p className="mt-5 text-foreground/65 max-w-md">
              Trust is earned, not requested. If you don't see your question, write to us at{' '}
              <a
                href="mailto:info@adifoundation.in"
                className="font-semibold text-saffron-600 dark:text-saffron-300 hover:underline"
              >
                info@adifoundation.in
              </a>
              .
            </p>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-8"
          >
            <Accordion
              type="single"
              collapsible
              className="rounded-3xl border border-border/70 bg-card overflow-hidden"
              data-testid="faq-accordion"
            >
              {FAQS.map((f, i) => (
                <AccordionItem
                  value={`item-${i}`}
                  key={f.q}
                  className="border-b last:border-b-0 border-border/60 px-5"
                >
                  <AccordionTrigger
                    data-testid={`faq-q-${i}`}
                    className="py-5 text-left font-display text-lg md:text-xl font-semibold hover:text-saffron-600 hover:no-underline"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 text-base leading-relaxed text-foreground/70">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
